import React from 'react';
import { Ban, AlertTriangle, Loader2 } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { Label } from '../../../components/ui/label';
import { Textarea } from '../../../components/ui/textarea';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../../../components/ui/select';
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle,
} from '../../../components/ui/dialog';

export const CancelInvoiceDialog = ({
  open, onOpenChange, count, cancelReasons,
  cancelReason, setCancelReason, cancelNotes, setCancelNotes, processing, onConfirm,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md" data-testid="bulk-cancel-dialog">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <Ban className="h-5 w-5 text-gray-600" />
          Cancel {count > 1 ? `${count} Invoices` : 'Invoice'}
        </DialogTitle>
        <DialogDescription>
          Cancelled invoices are for erroneous or test transactions. Orders must not have been delivered.
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-4 pt-2">
        <div className="p-3 bg-yellow-50 border border-yellow-200 rounded-lg text-sm">
          <div className="flex items-start gap-2">
            <AlertTriangle className="h-4 w-4 text-yellow-600 mt-0.5" />
            <div>
              <p className="font-medium text-yellow-800">Important:</p>
              <p className="text-yellow-700">Invoices for delivered orders cannot be cancelled. Use "Void" to create credit memos instead.</p>
            </div>
          </div>
        </div>

        <div>
          <Label>Cancellation Reason *</Label>
          <Select value={cancelReason} onValueChange={setCancelReason}>
            <SelectTrigger className="mt-1" data-testid="cancel-reason-select">
              <SelectValue placeholder="Select reason" />
            </SelectTrigger>
            <SelectContent>
              {cancelReasons.map(r => (
                <SelectItem key={r.value} value={r.value}>{r.label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div>
          <Label>Notes (optional)</Label>
          <Textarea
            placeholder="Additional notes..."
            rows={2}
            value={cancelNotes}
            onChange={(e) => setCancelNotes(e.target.value)}
            className="mt-1"
          />
        </div>

        <div className="flex gap-2 pt-2">
          <Button variant="outline" className="flex-1" onClick={() => { onOpenChange(false); setCancelReason(''); setCancelNotes(''); }}>
            Back
          </Button>
          <Button className="flex-1" onClick={onConfirm} disabled={processing || !cancelReason} data-testid="confirm-cancel-btn">
            {processing ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Ban className="h-4 w-4 mr-2" />}
            {processing ? 'Cancelling...' : 'Cancel Invoice(s)'}
          </Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);
